export default "__VITE_ASSET__Y9hKZA8X__"